import Grid from '@mui/material/Grid';

import DefaultCard from './defaultCard';
import TemplateCard from './templateCard';

import { FinalReportTemplate } from '../../../../interfaces/FinalReportTemplate';

interface TemplateGridProps {
  items: FinalReportTemplate[];
}

const TemplateGrid = ({ items }: TemplateGridProps) => {
  const filteredItems = items.filter((item) => !item.is_default);
  return (
    <Grid container spacing={2}>
      <Grid item>
        <DefaultCard />
      </Grid>
      {filteredItems.map((item, index) => (
        <Grid item key={item.id}>
          <TemplateCard
            title={item.template_name}
            index={index}
            template={item}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default TemplateGrid;
